import * as reducers from './reducers';
import effects from './effects';

const ChatModel = {
  state: {
    messages: [],
    show: false,
    lastActive: null,
    unread: 0,
    isInitialized: false,
  },
  reducers,
  effects,
};

export default ChatModel;
